import React, { FC } from 'react';
import Form from 'components/Form';

import { FinishusPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Finishus: FC<FinishusPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Finishus;
